//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Grid } from '@mui/material';
import AssetTotalStatus from './AssetTotalStatus';
import CircularPercentage from '@/components/_common/CircularPercentage';
import { selectJobAssets } from '../../../../redux/selectors/jobSelectors';
import { useAppSelector } from '@/redux/hooks';

const AssetProgress = () => {
  const assets = useAppSelector(selectJobAssets);

  if (!assets.components?.length) return null;

  return (
    <Grid sx={{ mb: 3, mt: -2 }} container justifyContent="center" alignItems="center">
      <AssetTotalStatus value={assets.total - assets.received} label="Pending" />

      <CircularPercentage value={(assets.received / assets.total) * 100} size={100}>
        <AssetTotalStatus value={assets.total} label="Total" />
      </CircularPercentage>

      <AssetTotalStatus value={assets.received} label="Received" />
    </Grid>
  );
};

export default AssetProgress;
